import { FC } from 'react';
import Paper from 'components/atoms/Paper';
import ShareSensorModal from 'components/organisms/ShareSensorModal';
import PeripheralDevices from './PeripheralDevices';
import { TableSorter } from 'components/molecules/TableSorter';
import { useTabDevices } from './resources/useTabDevices';
import TableFilter from 'components/organisms/TableFilter';
import './styles.scss';

const TabDevices: FC = () => {
  const {
    devices,
    currentPage,
    currentSize,
    totalPages,
    peripheralsTitle,
    shareSensorOptions,
    columns,
    expandedColumns,
    sorterOptions,
    initialFilters,
    onChangePage,
    onExpandDevice,
    onApplyFilters,
    loading,
  } = useTabDevices();

  return (
    <>
      <Paper>
        <h2>{peripheralsTitle}</h2>
        <div className={'TabDevices__buttons'}>
          <TableFilter
            loading={loading}
            initialFilters={initialFilters}
            onApply={onApplyFilters}
            isMultiple
          />
          <TableSorter
            label={sorterOptions.label}
            valueOptions={sorterOptions.valueOptions}
            value={sorterOptions.value}
            onChange={sorterOptions.onChangeSorter}
            disabled={sorterOptions.disabled}
            loading={sorterOptions.loading}
          />
        </div>
        <PeripheralDevices
          loading={loading}
          devices={devices}
          currentPage={currentPage}
          currentSize={currentSize}
          totalPages={totalPages}
          columns={columns}
          expandedColumns={expandedColumns}
          onExpand={onExpandDevice}
          onPagination={onChangePage}
        />
      </Paper>
      <ShareSensorModal
        modalOptions={shareSensorOptions}
        open={shareSensorOptions.shareSensorModalVisible}
        onCancel={shareSensorOptions.onCloseShareSensorModal}
      />
    </>
  );
}

export default TabDevices;